import * as React from 'react';

import styled from 'styled-components';

import { Color } from '../../color-picker-config';

export interface ColorPickerPaletteProps {
    color: string;
    palette: {
        [colorName: string]: Color;
    };
    dataId: string;
    onColorSelect: (color: any) => void;
}

interface StyledShadeProps {
    color: string;
}

const StyledColorPickerPalette = styled.table`
    padding: 16px;
    border-collapse: separate;
    width: 100%;
`;

const StyledColorName = styled.td`
    font: 400 12px open-sans;
    width: 8em;
`;

const StyledShade = styled.td<StyledShadeProps>`
    width: 30px;
    height: 20px;
    background-color: ${(props) => props.color};
    cursor: pointer;
`;

const StyledDiv = styled.div`
    width: 100%;
    height: 100%;
    position: relative;
    ${StyledShade}:hover &::before, ${StyledShade}.active &::before {
        content: '';
        display: block;
        border: 2px solid #ffffff;
        position: absolute;
        top: -1px;
        bottom: -1px;
        left: -1px;
        right: -1px;
    }
`;

const StyledDivider = styled.td`
    width: 5px;
    height: 20px;
`;

export const ColorPickerPalette: React.FC<React.PropsWithChildren<ColorPickerPaletteProps>> = ({
    color,
    palette,
    dataId,
    onColorSelect,
    ...props
}) => {
    const tableRows = Object.keys(palette).map((colorName) => (
        <tr key={colorName}>
            <StyledColorName>{colorName}</StyledColorName>
            <StyledDivider />
            <StyledShade
                color={palette[colorName].base}
                className={color === palette[colorName].base ? 'active' : ''}
                onClick={() => onColorSelect(palette[colorName].base)}
            >
                <StyledDiv />
            </StyledShade>
            <StyledDivider />
            {palette[colorName].shades.map((colorShade, index) => (
                <StyledShade
                    key={index}
                    color={colorShade}
                    className={color === colorShade ? 'active' : ''}
                    onClick={() => onColorSelect(colorShade)}
                >
                    <StyledDiv />
                </StyledShade>
            ))}
            <StyledDivider />
            {palette[colorName].tints.map((tint, index) => (
                <StyledShade
                    color={tint}
                    key={index}
                    className={color === tint ? 'active' : ''}
                    onClick={() => onColorSelect(tint)}
                >
                    <StyledDiv />
                </StyledShade>
            ))}
        </tr>
    ));
    return (
        <StyledColorPickerPalette data-test-id={`${dataId}`} {...props}>
            <tbody>{tableRows}</tbody>
        </StyledColorPickerPalette>
    );
};
